import type { ViewState } from '../types/warehouse.types';
import { Theme } from '@material-ui/core';

export interface GridRendererConfig {
  gridSize: number;
  lineWidth: number;
  lineDash: number[];
}

export class GridRenderer {
  private config: GridRendererConfig;
  private theme: Theme;

  constructor(theme: Theme, config?: Partial<GridRendererConfig>) {
    this.theme = theme;
    this.config = {
      gridSize: 100,
      lineWidth: 1,
      lineDash: [2, 8],
      ...config
    };
  }

  render(ctx: CanvasRenderingContext2D, canvasWidth: number, canvasHeight: number, viewState: ViewState): void {
    const { gridSize, lineWidth, lineDash } = this.config;
    const { scale, offsetX, offsetY } = viewState;

    const startX = Math.floor(-offsetX / gridSize) * gridSize;
    const endX = canvasWidth / scale - offsetX + gridSize;
    const startY = Math.floor(-offsetY / gridSize) * gridSize;
    const endY = canvasHeight / scale - offsetY + gridSize;

    ctx.strokeStyle = this.theme.palette.storageUi.backgroundSecondary;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(lineDash);

    ctx.beginPath();

    for (let x = startX; x < endX; x += gridSize) {
      const screenX = (x + offsetX) * scale;
      ctx.moveTo(screenX, 0);
      ctx.lineTo(screenX, canvasHeight);
    }

    for (let y = startY; y < endY; y += gridSize) {
      const screenY = (y + offsetY) * scale;
      ctx.moveTo(0, screenY);
      ctx.lineTo(canvasWidth, screenY);
    }

    ctx.stroke();
    ctx.setLineDash([]);
  }
}
